import queryString from 'query-string';
import { useEffect, useState } from 'react';

import { FilestackImageData, RandomGradProgram } from 'api/types/shared.types';
import { TileCarousel } from 'components/TileCarousel';
import { CmsApiRandomGradProgramsBlockData } from 'modules/cms/api/types/CmsApiRandomGradPrograms';
import { shuffleArray } from 'utils/functional';
import { getJson } from 'utils/http';
import { listingSearchHomePath } from 'utils/searchHomePages';

const getGradPrograms = (areasOfStudy: string[] | null | undefined) => {
  const args = queryString.stringify({
    area: areasOfStudy || [],
  });
  const url = `/data/website/random-grad-programs?${args}`;
  return getJson(url).then(
    // @ts-expect-error TS(2345): Argument of type '({ gradPrograms }: { gradProgram... Remove this comment to see the full error message
    ({ gradPrograms }: { gradPrograms: Array<RandomGradProgram> }) =>
      gradPrograms.map((gradProgram) => ({
        city: gradProgram.addressCity,
        id: gradProgram.id,
        logo: gradProgram.logo,
        orgName: gradProgram.schoolName,
        name: gradProgram.name,
        state: gradProgram.addressStateCode,
        url: gradProgram.url,
      }))
  );
};

type Props = {
  data: CmsApiRandomGradProgramsBlockData;
};

export function CmsRandomGradProgramsBlock({
  data: { areasOfStudy, headline },
}: Props) {
  const [gradPrograms, setGradPrograms] = useState([]);
  useEffect(() => {
    getGradPrograms(areasOfStudy).then(
      (
        programs: Array<{
          city?: string;
          id?: string;
          logo?: FilestackImageData;
          objectID?: string;
          orgName?: string;
          name?: string;
          state?: string;
          url?:
            | string
            | {
                en: string;
                es: string;
                pt: string;
              };
        }>
      ) => {
        // @ts-expect-error TS(2345): Argument of type '{ city?: string | undefined; id?... Remove this comment to see the full error message
        setGradPrograms(shuffleArray(programs));
      }
    );
  }, [areasOfStudy]);
  return (
    <TileCarousel
      headline={headline}
      results={gradPrograms}
      seeAllText={
        /* TRANSLATORS: Link to grad program search */
        getText('See all Grad Programs')
      }
      seeAllUrl={`${listingSearchHomePath('GRAD_PROGRAM')}?q=`}
      listingType="GRAD_PROGRAM"
    />
  );
}
